import styled, { css } from 'styled-components/macro'

export const Container = styled.div`
  transition: margin 300ms cubic-bezier(0.17, 0.04, 0.03, 0.94);
`;